const firebaseConfig = {
    apiKey: "AIzaSyCpTMobw0IDtwgvx0Z0WBh--xxf_VVFvKU",
    authDomain: "creative-agency5101.firebaseapp.com",
    databaseURL: "https://creative-agency5101.firebaseio.com",
    projectId: "creative-agency5101",
    storageBucket: "creative-agency5101.appspot.com",
    messagingSenderId: "971742481850",
    appId: "1:971742481850:web:3221b6637387365bcda183"
  };

  export default firebaseConfig;